import React, {useEffect, useState} from 'react';
import AuthLayout from "components/AuthLayout";
import {Information, Mail} from "assets/icons";
import {EMAIL_REGEX} from "helper/helper";
import Button from "components/button";
import useModal from "components/modal/useModal";
import ApiDatabase from 'server';
import UseContext from "hooks/useContext";

const Forgot = () => {
    const {toggle} = useModal();
    const {email, setEmail} = UseContext()
    const [validEmail, setValidEmail] = useState(false)
    const [errMsg, setErrMsg] = useState(false)
    const [sucess, setSucess] = useState(false)
    const [navigating, setNavigating] = useState(false)

    useEffect(() => {
        setValidEmail(EMAIL_REGEX.test(email))
    }, [email])


    const handleSubmit = async (e) => {
        e.preventDefault()

        if (validEmail) {
            setErrMsg(false)
            ApiDatabase.postTokenPwdMail({email},
                (data)=>{
                    if (data.errors) {
                        setValidEmail(true)
                    } else {
                        setSucess(true)
                    }
                },
            (err)=>{console.log(err)})
        } else {
            setErrMsg(true)
        }
    }
    if (sucess && navigating === false) {
        setNavigating(true);
        window.setTimeout(() => {
            toggle('tok_u_tokenPwd')
        }, 3000)
    }
    return (
        <AuthLayout>
            {sucess ? (
                <>
                    <div className="text-left flex flex-col gap-2">
                        <h1 className="text-2xl tab:text-3xl font-medium text-[#111827]">
                            Lien de connexion
                        </h1>
                        <p className="text-gray-500 text-sm tab:text-base">
                            Si un compte existe pour {email}, vous recevrez un e-mail avec un lien sous peu. Pensez aux courriers indésirables.
                        </p>
                    </div>
                </>
            ) : (
                <>
                    <div className="text-left flex flex-col gap-2">
                        <h1 className="text-2xl tab:text-3xl font-medium text-[#111827]">
                            Mot de passe oublié
                        </h1>
                        <p className="text-gray-500 text-sm tab:text-base">
                            Indiquez votre e-mail pour recevoir un lien de réinitialisation.
                        </p>
                    </div>
                    {errMsg && (
                        <div className="bg-red-50 rounded-lg px-4 py-3 flex items-center gap-3">
                            <Information wh={20} color={'#EF4444'}/>
                            <p className="text-red-700 text-sm">Veuillez bien remplir les champs.</p>
                        </div>
                    )}
                    <form className="space-y-4 w-full min-w-0">
                        <div className="grid grid-cols-12 gap-3">
                            <div className="col-span-12">
                                <label className="block ft-sm font-medium text-gray-500">E-mail</label>
                                <div className="relative text-[#6B7280]">
                                    <input
                                        name="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="w-full h-10 pl-8 pr-3 text-base border rounded-lg placeholder-gray-600"
                                        type="email"
                                        required
                                    />
                                    <div className="absolute inset-y-0 left-0 flex items-center px-2 pointer-events-none">
                                        <Mail wh={20} strokeW={2} color={'#666666'}/>
                                    </div>
                                </div>
                                <p className={email && !validEmail ? "text-[#FF9600] flex flex-row gap-4 items-center" : "hidden"}>
                                    <span><Information wh={20} color={'#FF9600'}/></span>
                                    Veuillez indiquer une adresse mail valide.
                                </p>
                            </div>
                        </div>
                        <div className="flex justify-end items-center">
                            <Button size={'LG'} onClick={handleSubmit}>M'envoyer un lien</Button>
                        </div>
                    </form>
                </>
            )}
        </AuthLayout>
    );
};

export default Forgot;